import { Modal } from "@mui/material";
import { CommonBatchBrandForm } from "../../components/brand-batch/brand-batch-form";
import { Brand } from "../playground/types";
import ModalBox from "../../components/common/modal";

export const BatchCreate: React.FC<{
  brandData: Brand;
  onClose: () => void;
}> = ({ brandData, onClose }) => {
  return (
    <Modal open={true} onClose={onClose} aria-labelledby="brand-modal">
      <ModalBox title="Create New Batch">
        <CommonBatchBrandForm
          onClose={onClose}
          type="batch"
          data={{
            brand_id: brandData.id,
            ...brandData,
            name: "",
          }}
        />
      </ModalBox>
    </Modal>
  );
};
